import React from 'react'
import { FormattedMessage } from "gatsby-plugin-intl"
import * as classes from './overview.module.scss'

import Container from '../container/container';
import OverviewThumbnails from './overviewthumbnails';

export default function Overview({ data }) {
    return (
        <main className={classes.MainContent}>
            <Container>
                <h2 className="text-center"><FormattedMessage id="title_360" /></h2>
                <p className="text-center">
                    <FormattedMessage id="body_360" />
                </p>
            
                <div className="row mb-5">
                    <OverviewThumbnails data={data} type="tour" />
                </div>
            </Container>

            <Container>
                <h3 className="text-center"><FormattedMessage id="title_photo" /></h3>
                <p className="text-center">
                    <FormattedMessage id="body_photo" />
                </p>
            
                <div className="row mb-5">
                    <OverviewThumbnails data={data} type="picture" />
                </div>
            </Container>

            <Container>
                <h3 className="text-center"><FormattedMessage id="title_vr" /></h3>
                <p className="text-center">
                    <FormattedMessage id="body_vr" />
                </p>
            
                <div className="row">
                    <OverviewThumbnails data={data} type="video" />
                </div>  
            </Container>         
        </main>
    )
}